import React from 'react';
import { Container, Row, Col, Card } from "react-bootstrap";
import { Icon } from 'semantic-ui-react';


const Kartu = () => (
    <>
        <Container>
            <Row>
                <Col>
                    <Card.Img variant="Right" src="https://i.pinimg.com/564x/37/c3/33/37c333b87a7bb91cebb9a3ff3073df0d.jpg" style={{ width: '18rem' }} alt="" />
                </Col>
                <Col>
                    <Card.Body>
                        <Card.Title>Hello i'm Herka</Card.Title>
                        <Card.Text className="text-left">
                            Front-End Developer based on Padang Indonesia, Herka is a free thinker, who also happens to love learning and read books, he is currently pursuing teaching himself learn programming language as Front-End especially ReactJs, Back-End developer, and UI - UX in his time.
                        </Card.Text>
                        <hr />
                    </Card.Body>
                    <div className="ml-3">
                        <a href="https://wa.me/6282174638792" target="_blank/rel-noopener">
                            <Icon link name='whatsapp' size='big' style={{ color: 'black' }} />
                        </a>
                        <a href="https://instagram.com/herkahahaha" target="_blank/rel-noopener">
                            <Icon link name='instagram' size='big' style={{ color: 'black' }} />
                        </a>
                        <a href="mailto:herkahahaha@gmail.com" target="_blank/rel-noopener">
                            <Icon link name='mail' size='big' style={{ color: 'black' }} />
                        </a>
                    </div>
                </Col>
            </Row>
        </Container>

    </>
);
export default Kartu;